<template>
  <div>
    <el-dialog
      top="3vh"
      width="800px"
      center
      :title="`${faceVideoPreviewObj.bankName} 扫脸视频预览`"
      :visible="faceVideoPreviewObj.visible"
      @close="$emit('update:face-video-preview-obj', {})"
    >
      <el-row :gutter="10">
        <div v-for="(item, index) in dataList" :key="item.type">
          <el-col :span="6" style="margin-bottom: 12px">
            <div class="video-description">{{ item.description }}</div>
            <div v-if="item.url">
              <video
                @click="HandlePreview(index)"
                width="180"
                height="200"
                style="margin: 2px; cursor: pointer"
                loop
                autoplay
                :src="item.url"
              ></video>
            </div>
            <div v-else class="video-empty">无视频</div>
          </el-col>
        </div>
      </el-row>
    </el-dialog>

    <FaceVideoPreviewerDialog
      :face-video-previewer-dialog-obj.sync="faceVideoPreviewerDialogObj"
    />
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import FaceVideoPreviewerDialog from "./FaceVideoPreviewerDialog";
import { getAccVideo } from "@/api/account";

export default {
  mixins: [mainCommon],
  props: {
    faceVideoPreviewObj: {
      type: Object,
    },
  },
  components: {
    FaceVideoPreviewerDialog,
  },
  data() {
    return {
      dataList: [],
      faceVideoPreviewerDialogObj: {},
    };
  },
  watch: {
    faceVideoPreviewObj(row) {
      if (row.visible) {
        this.getFaceVideo();
      }
    },
  },
  methods: {
    getFaceVideo() {
      getAccVideo(this.faceVideoPreviewObj.id).then((res) => {
        this.dataList = res.data;
      });
    },
    HandlePreview(index) {
      this.faceVideoPreviewerDialogObj = {
        dataList: this.dataList,
        index,
        visible: true,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__close,
/deep/ .el-icon-arrow-left,
/deep/ .el-icon-arrow-right {
  font-size: 35px;
}
/deep/ .face-video-preview .el-dialog__body {
  padding: 0 30px !important;
}
/deep/ .face-video-preview .el-dialog__headerbtn {
  right: -20px;
}
.description {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  padding: 10px 20px;
  z-index: 99;
  border-radius: 10px;
}
video {
  transform: rotate(-90deg);
}
#preview-dialog /deep/ {
  .el-dialog {
    background-color: transparent;
    box-shadow: none;
  }
  .el-dialog__title {
    color: #fff;
    text-shadow: 0px 0px 6px #000000c4;
    font-weight: 600;
  }
  .el-dialog__close {
    color: #fff;
  }
}
.backdrop-blur {
  backdrop-filter: blur(5px);
  background: rgba(0, 0, 0, 0.6);
}

.video-description {
  font-size: 13px;
  margin-bottom: 3px;
}
.video-preview-empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 50px;
  color: #fff;
  line-height: 50px;
  text-align: center;
  border: 1px solid #eee;
}
.video-empty {
  color: #ccc;
  text-align: center;
  border: 1px solid #eee;
  margin: 8px 0;
  width: 150px;
  height: 195px;
  border-radius: 3px;
  line-height: 195px;
}
</style>


// WEBPACK FOOTER //
// src/views/account/bank/FaceVideoPreviewDialog.vue